(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class ShopTheLookSection extends HTMLElement {
    connectedCallback() {
      this.section = this.querySelector('.shop-the-look');
      
      if (!this.section) return;

      this.markers = this.section.querySelectorAll('.shop-the-look__marker-button');

      for (const marker of this.markers) {
        marker.addEventListener('click', this.handleMarkerClick.bind(this));
      }

      document.addEventListener('click', this.handleOutsideClick.bind(this));
      document.addEventListener('keydown', this.handleEscapeKey.bind(this));
    }

    disconnectedCallback() {
      for (const marker of this.markers) {
        marker.removeEventListener('click', this.handleMarkerClick.bind(this));
      }

      document.removeEventListener('click', this.handleOutsideClick.bind(this));
      document.removeEventListener('keydown', this.handleEscapeKey.bind(this));
    }

    handleMarkerClick(event) {
      event.stopPropagation();
      const button = event.currentTarget;
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      // Close all other markers
      for (const otherMarker of this.markers) {
        if (otherMarker !== button) {
          this.closeMarker(otherMarker);
        }
      }

      // Toggle current marker
      if (isExpanded) {
        this.closeMarker(button);
      } else {
        this.openMarker(button);
      }
    }

    openMarker(button) {
      const contentId = button.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (!content) return;

      button.setAttribute('aria-expanded', 'true');
      content.hidden = false;

      // Position the content to stay within bounds
      this.positionContent(button, content);
    }

    positionContent(button, content) {
      const container = this.section.querySelector('.shop-the-look__image-container');
      if (!container) return;

      // Wait for next frame to ensure content is rendered and has dimensions
      requestAnimationFrame(() => {
        // Reset positioning
        content.style.left = '';
        content.style.right = '';
        content.style.top = '';
        content.style.bottom = '';
        content.style.transform = '';
        content.style.maxWidth = '';

        // Get bounding rectangles
        const containerRect = container.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        const contentRect = content.getBoundingClientRect();

        // Calculate button position WITHIN container (not viewport)
        const buttonLeftInContainer = buttonRect.left - containerRect.left;
        const buttonTopInContainer = buttonRect.top - containerRect.top;
        const buttonCenterXInContainer = buttonLeftInContainer + (buttonRect.width / 2);
        const buttonBottomInContainer = buttonTopInContainer + buttonRect.height;

        // Calculate content dimensions
        const contentWidth = contentRect.width;
        const contentHeight = contentRect.height;

        // Calculate available space within container
        const spaceBelow = containerRect.height - buttonBottomInContainer;
        const spaceAbove = buttonTopInContainer;
        const neededSpaceBelow = contentHeight + 12;

        // First check max width constraint
        const maxAllowedWidth = containerRect.width - 32;
        let finalContentWidth = contentWidth;
        if (contentWidth > maxAllowedWidth) {
          content.style.maxWidth = `${maxAllowedWidth}px`;
          finalContentWidth = maxAllowedWidth;
        }

        // Determine horizontal positioning (centered on button, constrained to container)
        let leftPosition = buttonCenterXInContainer - (finalContentWidth / 2);
        
        // Constrain to container bounds (with 16px padding)
        const minLeft = 16;
        const maxLeft = containerRect.width - finalContentWidth - 16;
        
        if (leftPosition < minLeft) {
          leftPosition = minLeft;
        } else if (leftPosition > maxLeft) {
          leftPosition = maxLeft;
        }

        // Determine vertical positioning
        let topPosition;
        if (neededSpaceBelow > spaceBelow && spaceAbove > spaceBelow) {
          // Position above button
          topPosition = buttonTopInContainer - contentHeight - 12;
        } else {
          // Position below button
          topPosition = buttonBottomInContainer + 12;
        }

        // Set final positions (relative to container)
        content.style.left = `${leftPosition}px`;
        content.style.top = `${topPosition}px`;
        content.style.transform = 'none';
      });
    }

    closeMarker(button) {
      const contentId = button.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      button.setAttribute('aria-expanded', 'false');

      if (content) {
        content.hidden = true;
      }
    }

    handleOutsideClick(event) {
      const clickedInsideMarker = event.target.closest('.shop-the-look__marker');

      if (!clickedInsideMarker) {
        for (const marker of this.markers) {
          this.closeMarker(marker);
        }
      }
    }

    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        for (const marker of this.markers) {
          if (marker.getAttribute('aria-expanded') === 'true') {
            this.closeMarker(marker);
            marker.focus();
          }
        }
      }
    }
  }

  customElements.define('shop-the-look-section', ShopTheLookSection);

  } catch(e) { console.error(e); }
})();
})();
